// extracted by mini-css-extract-plugin
module.exports = {"button":"SocialShareButton_button__6b1Tc"};